// 域名
const host = ()=>{
    return 'https://es.xichuanwh.com/';
}

const objectToQueryString = (obj) => {  
    // 去除可能的属性名或值中的非法字符  
    const params = Object.entries(obj)  
        .map(([key, value]) => {  
            // 假设value是字符串，如果不是，需要转换为字符串  
            let strValue = String(value);  
            // 去除值尾部的逗号（如果有）  
            if (strValue.endsWith(',')) {  
                strValue = strValue.slice(0, -1);  
            }  
            // 使用encodeURIComponent来编码键和值  
            return encodeURIComponent(key) + '=' + encodeURIComponent(strValue);  
        })  
        .join('&'); // 使用&符号连接参数对  
  
    return params;  
}  

// 日期时间格式转换
const newDateFormat_ = (dateStr)=>{
    const date = new Date(dateStr);

    // 提取年、月、日、时、分、秒
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 组合成新的时间格式
    const newDateFormat = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return newDateFormat;
}


export default{
    objectToQueryString,
    newDateFormat_,
    host
}